<template>
      <section class="skills" id="skills">
              <div class="title-container">
                <h2 class="title">Moje Umiejętności</h2>
                <h3 class="description">Co potrafię?</h3>
             </div>
  <div class="skills-container">
                <div class="skill-bars-wrapper">
                <div class="skill-bars">
                    <div class="key-skills">
                      <h3>Najważniejsze umiejętności</h3>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>HTML</span>
                            <span>96%</span>
                        </div>
                        <div class="line html"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>CSS</span>
                            <span>91%</span>
                        </div>
                        <div class="line css"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>JavaScript</span>
                            <span>80%</span>
                        </div>
                        <div class="line js"></div>
                    </div>
                    <div class="bars">
                        <div class="info">
                            <span>Vue</span>
                            <span>54%</span>
                        </div>
                        <div class="line php"></div>
                    </div>
                    <div class="skill-background-square"></div>
                </div>
                </div>
                <div class="other-skills-wrapper">
                  <div class="other-skills-container">
                    <div class="other-skills">
                        <h2>Inne umiejętności *</h2>
                        <div class="box-container">
                        <div class="box">
                        <p>WordPress</p>
                        <p>Bootstrap</p>
                        <p>Firebase</p>
                        <p>Figma</p>
                        <p>Git</p>
                        </div>
                        <div class="box">
                        <p>Photoshop</p>
                        <p>Premiere Pro</p>
                        <p>Jira</p>
                        <p>MySQL</p>
                        <p>Docker</p>
                        </div>
                        </div>
                    </div>
                    <div class="background-square"></div>
                </div>
                </div>
            </div>

     <div class="reliability">
                      <h3>W bonusie</h3>
                      <div class="icons">
                      <i>ikona</i>
                      <div class="content">
                        <h3>x</h3>
                        <p>xyz</p>
                      </div>
                      </div>
                      <p>pasja</p>
                      <p>terminowość</p>
                      <p>dokladność</p>
                      <p>elastyczność</p>
                      <p>stały kontakt</p>
                </div>
    <!-- <div class="spacer blob1"></div> -->
    <div class="spacer blob1"></div>
    <!-- <div class="spacer blob2"></div> -->
    <!-- <div class="spacer blob3"></div> -->
    <div class="spacer blob3"></div>
    <!-- <p class="bg-text">UMIEM</p> -->
    <p class="bg-text second">UM</p>
    <p class="bg-text third">UMIEM</p>
    </section>
</template>

<script>
// import {ref} from 'vue'
export default {
    name: "Skills",
    mounted() {
      const skills = document.querySelectorAll('.progress-line')
      const text = document.querySelectorAll('.info span')
      const progress = document.querySelectorAll('.progress-line span')
      const header = document.querySelector('.key')
      // console.log(text);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');

            skills.forEach(element => {
                element.classList.add('active')
            })

            text.forEach(element => {
              element.classList.add('active')
            })

            progress.forEach(element => {
              element.classList.add('active')
            })

            // header.forEach(element => {
            //   element.classList.add('active')
            // })

            header.classList.add('active')

        }
      })
    });

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));
  }
    }

</script>

<style lang="scss" scoped>
/* #262534; */
.bg-text {
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 36%;
    z-index: -3;
    // opacity: 12%;
}
.second {
    top: 57%;
    left: 33%;
    transform: rotate(10deg);
    // transform: rotate(-9deg);
    //  top: 33%;
    // left: 36%;
     font-size: 390px;
}

.third {
    top: 77.5%;
    left: -2%;
    font-size: 380px;
}

.spacer {
    aspect-ratio: 900/600;
    width: 24%;
    // opacity: 12%;
    opacity: 90%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

// .blob1 {
//     background-image: url('@/assets/blob.svg');
//     position: absolute;
//     top: -4%;
//     left: 2%;
//     z-index: 2555;
// }

.spacer.blob1 {
  width: 44%;
}

.blob1 {
    background-image: url('@/assets/blob2.svg');
    position: absolute;
    top: 2%;
    left: -20%;
    transform: rotate(290deg);
     filter: blur(14px);
}



// .blob2 {
//     background-image: url('@/assets/blob3.svg');
//     position: absolute;
//     top: 39%;
//     left: 61.5%;
//     transform: rotate(86deg);
//     z-index: -5;
//      filter: blur(14px);
// }

// .blob3 {
//     background-image: url('@/assets/blob4.svg');
//     position: absolute;
//     top: 6%;
//     left: 89%;
//     filter: blur(14px);
// }


.spacer.blob3 {
  width: 44%;
}

  .blob3 {
      background-image: url('@/assets/blob5.svg');
      position: absolute;
      top: -4%;
      left: 66%;
      transform: rotate(81deg);
      // background-color: black;
      filter: blur(14px);
  }

// .title-container {
//   color: #fff;
// }

section.skills {
  position: relative;
  background-color: #fff;
  z-index: -2;
  padding: 4rem 0 7rem;
  overflow: hidden;
  }


.hidden {
  opacity: 0;
  transition: 1s;
}

.show {
  opacity: 1;
}

 .other-skills-container.hidden {
    opacity: 0;
    // filter: blur(5px);
     filter: blur(6px);
    transform: translateY(100%);
    transition: all 1s;
    @media(prefers-reduced-motion) {
      transition: none;
    }
  }

   .other-skills-container.show {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0px);
  }



// 
// .skills-container {
//   display: flex;
//   justify-content: center;
//   align-items: center;

// }



// @keyframes showSkills {
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// }

// .skills-container.hidden .title-container {
//   padding-bottom: 10rem;
// }

// .skills-container.visible .title-container {
//   padding-bottom: 10rem;
// }

// /* .skills-container.hidden  {
//   animation: showSkills 1s;
// }

// .skills-container.visible {
//   animation: showSkills 1s;
// } */

// .skill-bars{
//   padding: 25px 30px;
//   width: 50%;
//   background: #fefefe;
//   box-shadow: 5px 5px 20px rgba(0,0,0,0.2);
//   border-radius: 10px;
// }
// .skill-bars .bar{
//   margin: 20px 0;
// }
// .skill-bars .bar:first-child{
//   margin-top: 0px;
// }
// .skill-bars .bar .info{
//   margin-bottom: 5px;
// }
// .skill-bars .bar .info span{
//   font-weight: 500;
//   font-size: 17px;
//   opacity: 0;
// }

// .skill-bars .bar .info span.active {
//   animation: showText 0.5s 1s linear forwards;
// }

// @keyframes showText {
//   100%{
//     opacity: 1;
//   }
// }

// // 
// .key {
//   opacity: 0;
//   text-align: center;
// }

// .key.active {
//   animation: showHeader 1s 0.5s linear forwards;
// }
// // 
// @keyframes showHeader {

//   100%{
//     opacity: 1;
//   }
// }


// .skill-bars .bar .progress-line{
//   height: 10px;
//   width: 100%;
//   background: #e0e0e0;
//   position: relative;
//   transform: scaleX(0);
//   transform-origin: left;
//   border-radius: 10px;
//   /* border: 1px solid #fefefe; */
//   box-shadow: inset 0 1px 1px rgba(0,0,0,0.05),
//               0 1px rgba(255,255,255,0.8);
//   /* animation: animate 1s 0.5s cubic-bezier(1,0,0.5,1) forwards; */
// }

// .skill-bars .bar .active {
//   animation: animate 1s 0.5s cubic-bezier(1,0,0.5,1) forwards;
// }

// @keyframes animate {
//   100%{
//     transform: scaleX(1);
//   }
// }
// .bar .progress-line span{
//   height: 100%;
//   position: absolute;
//   border-radius: 10px;
//   transform: scaleX(0);
//   transform-origin: left;
//   background: #F6BE00;
// }

// .bar .progress-line span.active {
//     animation: animate 1s 1.5s cubic-bezier(1,0,0.5,1) forwards;
// }

// .bar .progress-line.skill1 span{
//   width: 97%;
// }
// .bar .progress-line.skill2 span{
//   width: 94%;
// }
// .bar .progress-line.skill3 span{
//   width: 76%;
// }
// .bar .progress-line.skill4 span{
//   width: 68%;
// }
// .bar .progress-line.skill5 span{
//   width: 55%;
// }

// .progress-line span::before{
//   position: absolute;
//   content: "";
//   top: -10px;
//   right: 0;
//   height: 0;
//   width: 0;
//   border: 7px solid transparent;
//   border-bottom-width: 0px;
//   border-right-width: 0px;
//   border-top-color: #000;
//   opacity: 0;
//   animation: showText2 0.5s 2s linear forwards;
// }
// .progress-line span::after{
//   position: absolute;
//   top: -28px;
//   right: 0;
//   font-weight: 500;
//   background: #000;
//   color: #fff;
//   padding: 1px 8px;
//   font-size: 12px;
//   border-radius: 3px;
//   opacity: 0;
//   animation: showText2 0.5s 2s linear forwards;
// }
// @keyframes showText2 {
//   100%{
//     opacity: 1;
//   }
// }
// .progress-line.skill1 span::after{
//   content: "97%";
// }
// .progress-line.skill2 span::after{
//   content: "94%";
// }
// .progress-line.skill3 span::after{
//   content: "76%";
// }
// .progress-line.skill4 span::after{
//   content: "68%";
// }
// .progress-line.skill5 span::after{
//   content: "55%";
// }

// 
// 
// 


.skills-container {
  display: flex;
  margin-top: 1rem;
  // justify-content: center;
  // padding: 0 1rem;
}

.skill-bars-wrapper {
  width: 50%;
  display: flex;
  justify-content: flex-end;
}

.skill-bars {
  position: relative;
  width: 390px;
  height: 340px;
  background-color: #fefefe;
  border-radius: 2rem;
  box-shadow: 5px 5px 20px rgba(0,0,0,0.25);
  padding: 2.5rem 1.5rem 3.5rem;
  margin: 0 2rem 0;
}

.skill-background-square {
    width: 390px;
    height: 340px;
    background-color: #eee;
    border-radius: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
    transform: translate(-50%, -50%) rotate(-6deg);
    // box-shadow: 5px 5px 20px rgba(0,0,0,0.25);
}

.other-skills-wrapper {
  width: 50%;
  display: flex;
  justify-content: flex-start;
}

.skill-bars .key-skills {
  text-align: center;
  margin-bottom: 0.4rem;
}

.skills .skill-bars .bars{
    margin-bottom: 15px;
}

.skills .skill-bars .info{
    display: flex;
    margin-bottom: 5px;
    align-items: center;
    justify-content: space-between;
}
.skills  .skill-bars span{
    font-weight: 500;
    font-size: 1.2rem
}
.skills  .skill-bars .line{
    height: 5px;
    width: 100%;
    background: lightgrey;
    position: relative;
}
.skills  .skill-bars .line::before{
    content: "";
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    background: #F6BE00;;
}
 .skill-bars .html::before{
    width: 96%;
}
 .skill-bars .css::before{
    width: 91%;
}
 .skill-bars .js::before{
    width: 80%;
}
 .skill-bars .php::before{
    width: 54%;
}




.other-skills-container {
position: relative;
margin: 0 0 0 2rem;
.other-skills {
  z-index: 2;
  // position: relative;
  width: 390px;
    height: 340px;
  background-color: #fefefe;
  border-radius: 2rem;
  padding: 2.5rem 1.5rem 3.5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-shadow: -5px 5px 20px rgba(0,0,0,0.25);

    h2 {
      // padding: 0 0 0.5rem 1.5rem;
      text-align: center;
      font-size: 1.35rem;
      margin: 0 3.3rem 1rem 0;
    }

  .box-container {
    display: flex;
    margin-left: 2rem;

    .box {
      width: 50%;
      display: flex;
      flex-direction: column;
      
      // align-items: center;                                                  
      // text-align: left;
      // justify-content: center;

      p {
        font-size: 1.05rem;
        margin: 0.35rem 0;
      }
    }

  
  }
}

.background-square {
    width: 390px;
    height: 340px;
    background-color: #eee;
    border-radius: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
    transform: translate(-50%, -50%) rotate(6deg);
    // box-shadow: -5px 5px 20px rgba(0,0,0,0.25);
}
}

@media (min-width: 2250px) {
  .bg-text {
        font-size: 580px;
  }

    .bg-text.second {
      top: 55%;
      font-size: 510px;
}

    .bg-text.third {
      top: 80%;
      left: -2%;
      font-size: 500px;
    }


.blob1 {
    position: absolute;
    top: 25%;
    left: -12%;
    transform: rotate(290deg);
}

.blob2 {
    position: absolute;
    top: 35%;
    left: 59%;
    transform: rotate(84deg);
}

.blob3 {
    position: absolute;
    top: -14%;
    left: 67%;
    // transform: rotate(331deg);
}

section.skills {
  padding: 5rem 0 10rem;
  }

      .skill-bars{
        
  h2 {
    font-size: 1.7rem;
  }

  .bar {
    .info {
      // margin-bottom: 4px;

      span {
        // font-size: 15px;
        font-size: 21px;
      }
    }
      .progress-line span::after {
        font-size: 14px;
      }
    .progress-line {
      height: 12px;
    }
  }
}

.other-skills-container .other-skills {
  width: 465px;
  height: 380px;
  margin: 7rem auto 0;

}

.other-skills-container .background-square {
    width: 465px;
    height: 380px;
}

.other-skills-container .other-skills h2 {
  font-size: 1.65rem;
}

.other-skills-container .other-skills .box-container .box p {
  font-size: 1.3rem;
}


}

@media (max-width: 1440px) {
  .other-skills-container .other-skills {
    width: 26%;
  }

  .other-skills-container .background-square {
    width: 26%;
  }

}


@media (max-width: 1024px) {

  .bg-text {
    font-size: 260px;
  }

  .bg-text.second {
    top: 59.5%;
    left: 45%;
    // transform: rotate(126deg);
}

  .skills-container {
    margin-bottom: 3.5rem;
  }

  .skill-bars{
  width: 65%;
}

 .other-skills-container .other-skills {
    width: 35%;
    
  }

  .other-skills-container .background-square {
    width: 35%;
  }

  

}

@media (max-width: 768px) {

  .bg-text {
    font-size: 240px;
  }

  section.skills {
        padding: 4rem 0 5rem;
  }

  .skill-bars{
  width: 75%;

    h2 {
      font-size: 1.45rem;
    }

   .bar .progress-line {
      height: 8px;
    }

}

.bar.last {
  display: none;
}

 .other-skills-container .other-skills {
    width: 44%;

    h2 {
      font-size: 1.3rem;
    }
    .box-container {
      .box {
        p {
          font-size: 1rem;
        }
      }

    }
  }

  .other-skills-container .background-square {
    width: 44%;
  }



 

}

@media (max-width: 425px) {
  .skill-bars{
  width: 80%;
  padding: 14px 18px;

  h2 {
    font-size: 1.25rem;
  }

  .bar {
    .info {
      margin-bottom: 4px;

      span {
        font-size: 15px;
      }
    }
      .progress-line span::after {
        font-size: 11px;
      }
    .progress-line {
      height: 7px;
    }
  }
}


  .other-skills-container .other-skills {
    width: 75%;

    h2 {
      font-size: 1.2rem;
      margin: 0 1rem 1rem 0;
    }
  }

  .other-skills-container .background-square {
    width: 75%;
  }

  .bg-text.second,
  .bg-text.third {
    display: none;
  }
}
</style>